import * as React from 'react';
import { Check } from 'lucide-react';
import { Button } from '@ooh/ui/components/button';
import { cn } from '@ooh/ui/lib/utils';

interface QuickAddOfferToastProps {
  message: string;
  actionLabel?: string;
  onAction?: () => void;
  showAction?: boolean;
  tone?: 'success' | 'warning';
}

export function QuickAddOfferToast({
  message,
  actionLabel,
  onAction,
  showAction = Boolean(actionLabel),
  tone = 'success',
}: QuickAddOfferToastProps) {
  return (
    <div
      className={cn(
        'flex items-start gap-3 rounded-xl border px-4 py-3 shadow-sm',
        tone === 'success'
          ? 'border-emerald-200 bg-emerald-50 text-emerald-950'
          : 'border-amber-200 bg-amber-50 text-amber-950',
      )}
      data-testid="quick-add-offer-toast"
    >
      <span
        className={cn(
          'mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full',
          tone === 'success' ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700',
        )}
      >
        <Check className="h-3.5 w-3.5" />
      </span>

      <div className="min-w-0 flex-1 space-y-1">
        <p className="text-[13px] font-medium leading-5">{message}</p>
        {showAction && actionLabel ? (
          <div>
            <Button
              type="button"
              variant="inline"
              size="xs"
              onClick={onAction}
              data-testid="quick-add-offer-toast-action"
            >
              {actionLabel}
            </Button>
          </div>
        ) : null}
      </div>
    </div>
  );
}
